/*
Scripts File

Developed by:
URL:

Include custom js functions here. This file loads in the footer to help with load time.
*/

// as the page loads, call these scripts

jQuery(document).ready(function($) {

  $('.hamburger-icon').click(function(event) {
    event.preventDefault();
    $('#nav-icon').toggleClass('open');
    $('.flyout-menu--right').toggleClass('hide-right');
    $('.flyout-menu--left').addClass('hide-left');
    $('#account-close-menu').addClass('hide');
    $('#account-open-menu').removeClass('hide');
    return false;
  });

  //Expand Event
  $('.expand-btn').click(function() {
    $(this)
      .parents('.card-event')
      .find('.event-content')
      .slideToggle();
  });

  $('.popup-btn').click(function() {
    $('.popup-wrapper').css('display','flex');
    $('.popup-wrapper').css('visibility','visible');
  });

  // If an event gets to the wrapper
  $(".popup-wrapper").click(function(){
    $('.popup-wrapper').fadeOut();
  });

  $(".popup-close-btn").click(function(){
    $('.popup-wrapper').fadeOut();
  });

  // Prevent events from getting pass .popup
  $(".popup-content").click(function(e){
    e.stopPropagation();
  });

  $("#video-button").click(function(){
    var video = $("#home-video").get(0);
    if (video.paused === false) {
        video.pause();
    } else {
        video.play();
    }

    return false;
  });

  function scrollVideo() {
    var offsetRange = $(window).height() / 4,
        offsetTop = $(window).scrollTop() + offsetRange + $("#header").outerHeight(true),
        offsetBottom = offsetTop + offsetRange;

    $("#home-video").each(function () {

      var y1 = $(this).offset().top;
      var y2 = offsetTop;

      if (y1 + $(this).outerHeight(true) < y2 || y1 > offsetBottom) {
        $(this)[0].pause();
        $('.video-bar-top').css({
          top: 0,
        });
        $('.video-bar-bottom').css({
          bottom: 0,
        });

      } else {
        $(this)[0].play();
        $('.video-bar-top').css({
          top: '-50%',
        });
        $('.video-bar-bottom').css({
          bottom: '-50%',
        });
      }
    });
  }


  $(window).scroll(function() {
    scrollVideo();

    if ($(this).scrollTop() > 0) {
      $('.hero--content').css({
        opacity: 0, // animate slideUp
        transform: 'translateX(-100px)',
      });
      $('#home-hero-bg').css({
        opacity: 0, // animate slideUp
        transform: 'translateX(100px)',
      });
    } else {
      $('.hero--content').css({
        opacity: 1, // animate slideUp
        transform: 'translateX(0)',
      });
      $('#home-hero-bg').css({
        opacity: 1, // animate slideUp
        transform: 'translateX(0)',
      });
    }
  });


  // Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, "slow", function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
}); /* end of as page load scripts */



// WEBPACK FOOTER //
// ../riz3-child/lib/js/scripts.js